import React from 'react';
import { IconButton as BaseIconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import CloseIcon from 'src/components/icons/Close';
import { withDefaults } from '../../utils/withDefaults';
const RootRoot = styled(BaseIconButton)({
  '&:hover': {
    backgroundColor: 'transparent'
  }
});
export const Root = withDefaults(RootRoot, {
  children: /*#__PURE__*/React.createElement(CloseIcon, null)
});